export default __webpack_public_path__ + "static/media/LineChartBlue.15bc67c2.svg";